import React, { useEffect } from "react";
import Modal, { CommonModalProps } from "..";
import { CircularProgress, Stack, Typography } from "@mui/material";
import { Warning } from "@mui/icons-material";

export type ModalLoaderElementProps = {
  title: string;
  body: string;
  warning?: string;
};

export type ModalLoaderProps = CommonModalProps<ModalLoaderElementProps>;

const ModalLoader = React.forwardRef<any, ModalLoaderProps>((props, ref) => {
  const { closeModal, ...elementProps } = props;
  const { title, body, warning } = elementProps;

  return (
    <Modal
      title=""
      reference={ref}
      closeModal={closeModal}
      width={550}
      hideHeader={true}
      subheader={
        <Typography margin={2} variant="subtitle2" fontWeight={600}>
          {title}
        </Typography>
      }
      footer={
        warning && (
          <Typography display="inline-flex" alignItems="center" color={"warning.main"}>
            <Warning sx={{ marginRight: 1 }} /> {warning}
          </Typography>
        )
      }
    >
      <Stack>
        <CircularProgress
          size={80}
          color="primary"
          sx={{
            alignSelf: "center",
            marginBottom: "10px",
          }}
        />
        <Typography display="inline-flex" alignItems="center">
          {body}
        </Typography>
      </Stack>
    </Modal>
  );
});

export default ModalLoader;
